var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sidebar-right",
    {
      class: [
        "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400",
        { open: _vm.show },
      ],
      on: { overlayClicked: _vm.outside },
    },
    [
      _c("div", { staticClass: "scrollbar-inner" }, [
        _c(
          "div",
          {
            staticClass:
              "card-header mt-0 d-flex align-items-center chat-header-title navbar-height bg-navy rounded-0",
          },
          [
            _c("div", { staticClass: "d-block" }, [
              _c("div", { staticClass: "header-title" }, [
                _vm._v("Timesheet"),
                _c("span", { staticClass: "bracket" }, [_vm._v(" { ")]),
              ]),
            ]),
            _c("div", { staticClass: "d-block ml-auto" }, [
              _c(
                "div",
                {},
                [
                  _c("flat-picker", {
                    staticClass: "form-control datepicker",
                    attrs: { config: { wrap: true, allowInput: false } },
                    on: {
                      "on-open": () => {},
                      "on-close": () => {},
                      "on-change": () => {
                        // this.fetchAllRecords()
                      },
                    },
                    model: {
                      value: _vm.selectedDate,
                      callback: function ($$v) {
                        _vm.selectedDate = $$v
                      },
                      expression: "selectedDate",
                    },
                  }),
                  _c(
                    "a",
                    {
                      staticClass:
                        "nav-link icon-shape icon-shape--26 icon-shape--white py-1 px-2 timesheet-icon",
                      attrs: {
                        "data-toggle": "",
                        "data-original-title": "Timesheet Entry",
                        "data-target": "offcanvasTimer",
                        "data-offcanvasfrom": "offcanvas",
                      },
                      on: { click: _vm._onCalendarClicked },
                    },
                    [
                      _vm._v(
                        "\n\n            " +
                          _vm._s(_vm.formattedDate) +
                          "\n            "
                      ),
                      _c("i", {
                        staticClass: "ml-2 ni ni-calendar-grid-58",
                        staticStyle: { "font-size": "20px" },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            {
              staticClass:
                "card-body d-flex justify-content-end align-items-center",
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: {
                        type: _vm.entryMode == "leave" ? "primary" : "outline",
                      },
                      on: {
                        click: function ($event) {
                          _vm.entryMode = "leave"
                        },
                      },
                    },
                    [_vm._v("Leave")]
                  ),
                  _c(
                    "base-button",
                    {
                      attrs: {
                        type:
                          _vm.entryMode == "projecttask"
                            ? "primary"
                            : "outline",
                      },
                      on: {
                        click: function ($event) {
                          _vm.entryMode = "projecttask"
                        },
                      },
                    },
                    [_vm._v("Project/Task")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("hr", { staticClass: "mt-0 mb-0" }),
          _vm.entryMode == "leave"
            ? _c(
                "div",
                { staticClass: "timesheetentryleave card-body" },
                [
                  _c("div", { staticClass: "form-group mb-3" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-control-label mb-0",
                        attrs: { for: "exampleFormControlTextarea1" },
                      },
                      [_vm._v("Leave Type")]
                    ),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100 radius-0 mb-2",
                      attrs: {
                        placeholder: "Search Bracket Here",
                        size: "small",
                        "value-key": "id",
                        filterable: "",
                      },
                      model: {
                        value: _vm.selectedLeaveType,
                        callback: function ($$v) {
                          _vm.selectedLeaveType = $$v
                        },
                        expression: "selectedLeaveType",
                      },
                    },
                    _vm._l(
                      ["Personal Leave", "Sick Leave"],
                      function (leaveType, index) {
                        return _c("el-option", {
                          key: index,
                          staticClass: "select-danger",
                          attrs: { value: leaveType, label: leaveType },
                        })
                      }
                    ),
                    1
                  ),
                  _c("div", { staticClass: "form-group mb-3" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-control-label mb-0",
                        attrs: { for: "exampleFormControlTextarea1" },
                      },
                      [_vm._v("Leave Duration")]
                    ),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100 radius-0 mb-2",
                      attrs: {
                        placeholder: "Search Bracket Here",
                        size: "small",
                        "value-key": "id",
                        filterable: "",
                      },
                      model: {
                        value: _vm.selectedLeaveDuration,
                        callback: function ($$v) {
                          _vm.selectedLeaveDuration = $$v
                        },
                        expression: "selectedLeaveDuration",
                      },
                    },
                    _vm._l(
                      _vm.selectedLeaveType == "Personal Leave"
                        ? [
                            "1st Half Day(PL)",
                            "2nd Half Day(PL)",
                            "Full Day(PL)",
                          ]
                        : [
                            "1st Half Day(SL)",
                            "2nd Half Day(SL)",
                            "Full Day(SHD)",
                          ],
                      function (ld, index) {
                        return _c("el-option", {
                          key: index,
                          staticClass: "select-danger",
                          attrs: { value: ld, label: ld },
                        })
                      }
                    ),
                    1
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-lg btn-block mt-3",
                      attrs: { type: "button" },
                      on: { click: _vm.handleLeaveEntry },
                    },
                    [
                      _vm._v(
                        "\n                   " +
                          _vm._s(_vm.isEdit ? "Update" : "Submit") +
                          " \n                  "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.entryMode == "projecttask"
            ? _c("div", { staticClass: "timesheetentrytask" }, [
                _vm.projects
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "card-body border mb-2 border-left-0 border-top-0 border-right-0 pb-3",
                      },
                      [
                        _c("div", { staticClass: "form-group mb-3" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-control-label mb-0",
                              attrs: { for: "exampleFormControlTextarea1" },
                            },
                            [_vm._v("Project#")]
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100 radius-0",
                            attrs: {
                              placeholder: "Search Bracket Here",
                              size: "small",
                              "value-key": "id",
                              filterable: "",
                            },
                            on: { change: _vm._onProjectSelected },
                            model: {
                              value: _vm.selectedProject,
                              callback: function ($$v) {
                                _vm.selectedProject = $$v
                              },
                              expression: "selectedProject",
                            },
                          },
                          _vm._l(
                            _vm.projects.data || [],
                            function (project, index) {
                              return _c("el-option", {
                                key: index,
                                staticClass: "select-danger",
                                attrs: { value: project, label: project.name },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tasks && _vm.tasks.data
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "card-body border-left-0 border-top-0 border-right-0 pb-3 pt-0",
                        class: { border: _vm.selectedTask },
                      },
                      [
                        _c("div", { staticClass: "form-group mb-3" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-control-label mb-0",
                              attrs: { for: "exampleFormControlTextarea1" },
                            },
                            [_vm._v("Bracket#")]
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100 radius-0",
                            attrs: {
                              placeholder: "Search Task Here",
                              size: "small",
                              filterable: "",
                              "value-key": "id",
                            },
                            model: {
                              value: _vm.selectedTask,
                              callback: function ($$v) {
                                _vm.selectedTask = $$v
                              },
                              expression: "selectedTask",
                            },
                          },
                          _vm._l(_vm.tasks.data, function (task, index) {
                            return _c("el-option", {
                              key: index,
                              staticClass: "select-danger",
                              attrs: { value: task, label: task.name },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedTask
                  ? _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "progress-label mb-3 justify-content-start",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "bg-dark text-white text-capitalize px-2",
                              attrs: {
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                                title: "",
                                "data-original-title":
                                  "5 out of 10 hours quoted on this Task",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.taskBudget.workedHours) +
                                  "/" +
                                  _vm._s(_vm.taskBudget.hours)
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal",
                            },
                            [_vm._v("hours")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "bg-dark text-white text-capitalize px-2",
                              attrs: {
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                                title: "",
                                "data-original-title":
                                  "17 hours ($170) per hour = $17,000",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.taskBudget.currency) +
                                  _vm._s(_vm.taskBudget.cost)
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal",
                            },
                            [_vm._v("quoted\n              on this Task")]
                          ),
                        ]
                      ),
                      _vm.selectedTask
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "progress-label mb-3 justify-content-start",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "bg-danger text-white text-capitalize px-2",
                                  attrs: {
                                    "data-toggle": "tooltip",
                                    "data-placement": "top",
                                    title: "",
                                    "data-original-title":
                                      "Project is 15 hours over quote",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.projectBudget.workedHours) +
                                      "/" +
                                      _vm._s(_vm.projectBudget.hours)
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal",
                                },
                                [_vm._v("hours")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "bg-dark text-white text-capitalize px-2",
                                  attrs: {
                                    "data-toggle": "tooltip",
                                    "data-placement": "top",
                                    title: "",
                                    "data-original-title":
                                      "17 hours ($170) per hour = $17,000",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.projectBudget.currency) +
                                      _vm._s(_vm.projectBudget.cost)
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal",
                                },
                                [
                                  _vm._v(
                                    "quoted\n              on this Project"
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.selectedTask
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "progress-label mb-0 justify-content-start",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "bg-success text-white text-capitalize px-2",
                                  attrs: {
                                    "data-toggle": "tooltip",
                                    "data-placement": "top",
                                    title: "",
                                    "data-original-title": "Due Date",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.deadline))]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal",
                                },
                                [_vm._v("deadline")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                false
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "card-body card-body border-bottom-0 border-right-0 border-left-0",
                        class: { border: _vm.selectedTask },
                      },
                      [
                        _c("form", { attrs: { action: "" } }, [
                          _c("div", { staticClass: "form-group mb-3" }, [
                            _c(
                              "label",
                              {
                                staticClass: "form-control-label mb-0",
                                attrs: { for: "exampleFormControlTextarea1" },
                              },
                              [
                                _vm._v(
                                  "You may like to extend this\n                quote"
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: {
                                type: "button",
                                "data-target": "offcanvasChangerequest",
                                "data-offcanvasfrom": "offcanvas",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Change Request\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-body border-bottom-0 border-right-0 border-left-0 timer-block",
                    class: { border: _vm.selectedTask },
                  },
                  [
                    _c("div", { staticClass: "timer-block__add" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-sm btn-info",
                          attrs: { href: "jaavascript:void(0);" },
                        },
                        [_vm._v("Add Time")]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-sm btn-outline-primary",
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function ($event) {
                              return _vm.addTime(10)
                            },
                          },
                        },
                        [_vm._v("Add 10")]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-sm btn-outline-primary",
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function ($event) {
                              return _vm.addTime(30)
                            },
                          },
                        },
                        [_vm._v("Add 30")]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-sm btn-warning float-right",
                          attrs: { href: "javascript:void(0);" },
                          on: { click: _vm.outside },
                        },
                        [_vm._v("My Timesheet")]
                      ),
                    ]),
                    _c("div", { staticClass: "timer-block__timer mt-4" }, [
                      _c("form", { attrs: { action: "" } }, [
                        _c("div", { staticClass: "row align-items-center" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "div",
                              { staticClass: "form-group mb-3" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-control-label",
                                    attrs: { for: "example-time-input-start" },
                                  },
                                  [_vm._v("Start Time:")]
                                ),
                                _c("el-time-select", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    size: "small",
                                    "picker-options": {
                                      start: "08:30",
                                      step: "00:15",
                                      end: "18:30",
                                    },
                                    placeholder: "Select time",
                                  },
                                  on: { change: _vm.onEndTimeSelect },
                                  model: {
                                    value: _vm.selectedStartTime,
                                    callback: function ($$v) {
                                      _vm.selectedStartTime = $$v
                                    },
                                    expression: "selectedStartTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "div",
                              { staticClass: "form-group mb-3" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-control-label",
                                    attrs: { for: "example-time-input-end" },
                                  },
                                  [_vm._v("End Time:")]
                                ),
                                _c("el-time-select", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    size: "small",
                                    "picker-options": {
                                      start: "08:30",
                                      step: "00:15",
                                      end: "18:30",
                                    },
                                    placeholder: "Select time",
                                  },
                                  on: { change: _vm.onEndTimeSelect },
                                  model: {
                                    value: _vm.selectedEndTime,
                                    callback: function ($$v) {
                                      _vm.selectedEndTime = $$v
                                    },
                                    expression: "selectedEndTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "row align-items-center" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "form-group mb-1" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "form-control-label",
                                  attrs: { for: "example-number-input-hours" },
                                },
                                [_vm._v("Hours:")]
                              ),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedHour,
                                      expression: "selectedHour",
                                    },
                                  ],
                                  staticClass: "form-control form-control-sm",
                                  attrs: { id: "exampleFormControlSelect1" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.selectedHour = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", [_vm._v("0")]),
                                  _c("option", [_vm._v("1")]),
                                  _c("option", [_vm._v("2")]),
                                  _c("option", [_vm._v("3")]),
                                  _c("option", [_vm._v("4")]),
                                  _c("option", [_vm._v("5")]),
                                  _c("option", [_vm._v("6")]),
                                  _c("option", [_vm._v("7")]),
                                  _c("option", [_vm._v("8")]),
                                  _c("option", [_vm._v("9")]),
                                  _c("option", [_vm._v("10")]),
                                  _c("option", [_vm._v("11")]),
                                  _c("option", [_vm._v("12")]),
                                  _c("option", [_vm._v("13")]),
                                  _c("option", [_vm._v("14")]),
                                  _c("option", [_vm._v("15")]),
                                  _c("option", [_vm._v("16")]),
                                  _c("option", [_vm._v("17")]),
                                  _c("option", [_vm._v("18")]),
                                  _c("option", [_vm._v("19")]),
                                  _c("option", [_vm._v("20")]),
                                  _c("option", [_vm._v("21")]),
                                  _c("option", [_vm._v("22")]),
                                  _c("option", [_vm._v("23")]),
                                  _c("option", [_vm._v("24")]),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "form-group mb-1" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "form-control-label",
                                  attrs: { for: "example-number-input-hours" },
                                },
                                [_vm._v("Minutes:")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedMinute,
                                    expression: "selectedMinute",
                                  },
                                ],
                                staticClass: "form-control form-control-sm",
                                attrs: {
                                  type: "number",
                                  value: "23",
                                  id: "example-number-input-hours",
                                },
                                domProps: { value: _vm.selectedMinute },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.selectedMinute = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "form-group mt-3" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "form-control-label mb-3",
                                  attrs: { for: "exampleFormControlTextarea1" },
                                },
                                [
                                  _vm._v(
                                    "Work completed on this\n                      task"
                                  ),
                                ]
                              ),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedDescription,
                                    expression: "selectedDescription",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "exampleFormControlTextarea1",
                                  rows: "3",
                                },
                                domProps: { value: _vm.selectedDescription },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.selectedDescription =
                                      $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success btn-lg btn-block",
                                attrs: { type: "button" },
                                on: { click: _vm.handleRegistration },
                              },
                              [
                                _vm._v(
                                  "\n                   " +
                                    _vm._s(_vm.isEdit ? "Update" : "Submit") +
                                    " \n                  "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }